import { Column } from "react-table";

export function createStickyMenuColumn<T extends object>(
  props: Partial<Column<T>>,
): Column<T> {
  const width = props.width !== undefined ? props.width : 38;
  const maxWidth = typeof width === "number" ? width : props.maxWidth;
  return {
    id: "actions",
    accessor: undefined,
    Header: "",
    disableSortBy: true,
    isStickyMenuColumn: true,
    ...props,
    width: width,
    maxWidth: maxWidth,
  };
}
